import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';
import { minorResultSharedStyles } from '../Results.styles';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useResultTextBlockStyles = makeStyles(() => ({
  textBlockSection: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  textCard: {
    position: 'relative',
    width: '100%',
    padding: 20,
    border: '1px solid #e4e4e7',
    borderRadius: 3,
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  textCardCollapsed: {
    height: 336,
  },
  textScrollArea: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
  },
  textContent: {
    color: colors.overlay,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: '20px',
    '& p, & h1, & h2, & h3, & ul, & ol': {
      margin: 0,
    },
    '& p, & ul, & ol': {
      lineHeight: '20px',
    },
    '& h1, & h2, & h3': {
      lineHeight: 'normal',
    },
  },
  textFade: {
    ...minorResultSharedStyles.fadeOverlay,
  },
  expandButton: {
    position: 'relative',
    zIndex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    height: 40,
    marginTop: -20,
    padding: '0 24px',
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    color: colors.primaryDark,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    letterSpacing: 0.28,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: colors.hoverSurface,
    },
    '&:active': {
      backgroundColor: colors.surface,
      transform: 'scale(0.98)',
    },
  },
  collapseButton: {
    display: 'inline-flex',
    marginTop: spacing.sm,
    padding: '8px 0',
    border: 0,
    background: 'transparent',
    color: colors.primaryDark,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    textDecoration: 'underline',
  },
}));
